import { RotateLeft, RotateRight } from '@material-ui/icons';
import React, { useState } from 'react';
import AliceCarousel from 'react-alice-carousel';
import { ImagesViewer } from '../images-viewer';
import ZoomIcon from './icon_zoom.svg';
import { SmartImage } from './smart-image';
import 'react-alice-carousel/lib/alice-carousel.css';
import './index.css';
const ImageItem = ({ image, type, rotate }) => {
    return (React.createElement(SmartImage, { degree: rotate, enableZoom: true, image: image, maxHeightPerc: 0.4, noPoints: true, type: type }));
};
export const ImageSlider = ({ images, selectedImage, type, imageType, jobResult }) => {
    const [firstImage] = images;
    const [rotationState, setRotationState] = useState(0);
    const [currentSelectedImage, setCurrentSelectedImage] = useState(selectedImage);
    const isSingleImage = images.length === 1;
    const rotateClass = () => `rotate deg${Math.abs(rotationState)} ${rotationState < 0 ? 'neg' : ''}`;
    const handleRotateLeft = () => {
        const rotate = rotationState - 90;
        if (rotate === -360)
            setRotationState(0);
        else
            setRotationState(rotate);
    };
    const handleRotateRight = () => {
        const rotate = rotationState + 90;
        if (rotate === 360)
            setRotationState(0);
        else
            setRotationState(rotate);
    };
    const onImageChange = (slice) => {
        setRotationState(0);
        setCurrentSelectedImage(slice.item);
    };
    const mapImages = images.map((image, index) => (React.createElement("div", { className: rotateClass(), key: image.url },
        React.createElement(ImageItem, { image: image, rotate: index === currentSelectedImage ? rotationState : 0 }))));
    const [zoom, setZoom] = useState(false);
    if (!firstImage) {
        return null;
    }
    return (React.createElement("div", { className: "job-modal__main_carousel", id: "job-modal__main_carousel" },
        React.createElement(ImagesViewer, { imageType: imageType, jobResult: jobResult, mainImage: firstImage },
            isSingleImage ? (React.createElement("div", { className: rotateClass() },
                React.createElement(ImageItem, { image: firstImage, rotate: rotationState, type: type }))) : (React.createElement(AliceCarousel, { activeIndex: currentSelectedImage, animationType: "fadeout", disableButtonsControls: true, disableDotsControls: false, items: mapImages, onSlideChanged: onImageChange })),
            React.createElement("div", { className: "footer-options" },
                React.createElement("div", { "aria-pressed": "false", className: "item", onClick: handleRotateLeft, role: "button" },
                    React.createElement(RotateLeft, null)),
                React.createElement("div", { "aria-pressed": "false", className: "item", onClick: handleRotateRight, role: "button" },
                    React.createElement(RotateRight, null)),
                React.createElement("div", { className: "zoom-icon", onClick: () => {
                        setZoom((prevState) => !prevState);
                    } },
                    React.createElement(ZoomIcon, null)),
                zoom && (React.createElement("div", { className: "image-overlay", onClick: () => {
                        setZoom((prevState) => !prevState);
                    } },
                    React.createElement("img", { src: isSingleImage
                            ? firstImage.url
                            : images[currentSelectedImage].url })))))));
};
